import Glider from 'glider-js'

export default class CtaSlider {

    constructor($view) {
        this.$view = $view;
        this.$slider = this.$view.find('.js-slides');
        this.$dots = this.$view.find('.js-dots');
        this.bind();
    }

    bind() {

        new Glider(this.$slider[0], {
            slidesToShow: 1,
            dots: this.$dots[0],
            draggable: true,
            scrollLock: true
        });

    }

}